<template>
    <div
        class="md-sold-detail broker"
        :class="{ mobile: isMobileSize, pc: !isMobileSize }"
    >
        <template v-if="isMobileSize">
            <DetailBanner ref="mobileBanner"></DetailBanner>
            <div class="f-col">
                <Provided
                    class="provided"
                    v-if="positionProvidedTop"
                    theme="broker"
                ></Provided>
            </div>
            <div class="detail-info f-col" ref="detailInfo">
                <div class="info-box">
                    <no-disclosure
                        v-if="hidePrice"
                        :des="cmpNondisclosureDes"
                    ></no-disclosure>
                    <p v-else class="first-price">
                        {{
                            $ft.formatCurrency({
                                value: showSoldPrice ? info.soldPrice : info.price,
                                noSpace: true,
                                currencySymbol
                            })
                        }}
                    </p>
                    <!-- Original Price and Est-Price start -->
                    <div class="second-box">
                        <template v-if="showSoldPrice && showListingPrice">
                            <span class="second-price">
                                {{ $ft.formatCurrency({ value: info.price, noSpace:true, currencySymbol }) }}
                            </span>
                            <span
                                v-if="trend"
                                class="trend"
                                :class="{
                                    up: info.soldPrice > info.price,
                                    down: info.soldPrice < info.price
                                }"
                            >
                                <span class="iconfont icon-trend-up"></span>
                                <span class="iconfont icon-trend-down"></span>
                                {{ trend }}
                            </span>
                        </template>
                        <est-price class="est-price"></est-price>
                    </div>
                    <!-- Original Price and Est-Price end -->
                </div>
                <div
                    v-if="showCalculator"
                    class="calculator"
                    :class="{ nodisclosure: hidePrice }"
                    @click="openCaculator('broker')"
                >
                    <span class="iconfont icon-caculator">
                        <span class="payment-text">
                            {{ cmpPaymentText }}
                        </span>
                    </span>
                    <label>
                        {{
                            $ft.formatCurrency({
                                value: hidePrice ? '-' : pricePerMonth,
                                noSpace: true,
                                currencySymbol
                            })
                        }} </label
                    >{{ $t('md-sold-detail.mo') }}
                </div>
                <!-- Calculator end -->
                <!-- Bath/Bed/Sqt start -->
                <div class="count">
                    <div class="child" v-if="info.bedrooms > 0">
                        <p class="iconfont icon-bed"></p>
                        <p>
                            <span class="number">
                                {{ count('bedrooms', info.bedrooms) }}
                            </span>
                            <span class="house">
                                {{ unit('bedrooms', info.bedrooms) }}
                            </span>
                        </p>
                    </div>
                    <div class="child" v-if="info.bathrooms > 0">
                        <p class="iconfont icon-bath"></p>
                        <p>
                            <span class="number">
                                {{ count('bathrooms', info.bathrooms) }}
                            </span>
                            <span class="house">
                                {{ unit('bathrooms', info.bathrooms) }}
                            </span>
                        </p>
                    </div>
                    <div
                        class="child"
                        v-if="info.sqft > 0 || info.totalAvailableAcres > 0"
                    >
                        <p class="iconfont icon-SqFt"></p>
                        <p>
                            <span class="number">
                                {{
                                    count(
                                        'sqft',
                                        info.sqft,
                                        info.totalAvailableAcres
                                    )
                                }}
                            </span>
                            <span class="house">
                                {{
                                    unit(
                                        'sqft',
                                        info.sqft,
                                        info.totalAvailableAcres
                                    )
                                }}
                            </span>
                        </p>
                    </div>
                </div>
                <p v-if="soldDate" class="sold-date">{{ soldDate }}</p>
                <div
                    ref="container"
                    class="detail-info-group-container"
                    :class="openReadMore ? 'open-read-more' : ''"
                >
                    <DetailInfoGroup
                        firstRowClass="single-column"
                    ></DetailInfoGroup>
                </div>
                <p class="read-more" v-if="showReadMore" @click="onReadMore">
                    <span>
                        {{
                            openReadMore
                                ? $t('md-sold-detail.readLessInfo')
                                : $t('md-sold-detail.readMoreInfo')
                        }}
                        <i
                            class="iconfont iconfont icon-arrow_04_down"
                            :class="{ rotate180: openReadMore }"
                        />
                    </span>
                </p>
            </div>
            <MLS
                :provided="!positionProvidedTop && 'broker'"
                class="f-col"
                theme="broker"
            ></MLS>
            <RequestButton theme="broker" :submitText="submitText" />
            <house-mask v-if="isShowMask" theme="broker" />
        </template>
        <template v-else>
            <DetailBanner></DetailBanner>
            <div class="detail-box f-col" ref="detailInfo" noMargin>
                <div class="detail-info">
                    <Provided
                        v-if="positionProvidedTop"
                        theme="broker"
                    ></Provided>
                    <div class="detail-info-price">
                        <div class="left-price">
                            <no-disclosure
                                v-if="hidePrice"
                                :des="cmpNondisclosureDes"
                            ></no-disclosure>
                            <p v-else class="first-price">
                                {{
                                    $ft.formatCurrency({
                                        value:  showSoldPrice
                                            ? info.soldPrice
                                            : info.price,
                                        noSpace: true,
                                        currencySymbol
                                    })
                                }}
                            </p>
                            <template v-if="showSoldPrice && showListingPrice">
                                <p class="second-price">
                                    {{ $ft.formatCurrency({ value: info.price, noSpace: true, currencySymbol}) }}
                                </p>
                                <span
                                    v-if="trend"
                                    class="trend"
                                    :class="{
                                        up: info.soldPrice > info.price,
                                        down: info.soldPrice < info.price
                                    }"
                                >
                                    <span
                                        class="iconfont icon-arrow_04_down rotate180"
                                    ></span>
                                    <span
                                        class="iconfont icon-arrow_04_down"
                                    ></span>
                                    {{ trend }}
                                </span>
                            </template>
                        </div>
                        <est-price class="est-price"></est-price>
                      
                        <!-- Tour Button end -->
                    </div>

                    <div class="calculator-count">
                        <div v-if="showCalculator" class="calculator-container">
                            <div
                                class="calculator"
                                :class="{ nodisclosure: hidePrice }"
                                @click="setPcCalculatorShow(true)"
                            >
                                <span class="iconfont icon-caculator">
                                    <span class="payment-text">
                                        {{ cmpPaymentText }}
                                    </span>
                                </span>
                                <label>
                                    {{
                                        $ft.formatCurrency({
                                            value: hidePrice ? '-' : pricePerMonth,
                                            noSpace: true,
                                            currencySymbol
                                        })
                                    }} </label
                                >{{ $t('md-sold-detail.mo') }}
                            </div>
                            <CalculatorBroker
                                v-if="pcCalculatorShow"
                                v-bind="caculatorData"
                                @close="setPcCalculatorShow(false)"
                            />
                        </div>
                        <div class="count">
                            <div
                                class="bed-count clearfix"
                                v-if="info.bedrooms > 0"
                            >
                                <p class="count-logo iconfont icon-bed"></p>
                                <p>
                                    <span class="number">
                                        {{
                                            count('bedrooms', info.bedrooms)
                                        }}
                                    </span>
                                    <span class="house">
                                        {{
                                            unit('bedrooms', info.bedrooms)
                                        }}
                                    </span>
                                </p>
                            </div>
                            <div
                                class="bath-count clearfix"
                                v-if="info.bathrooms > 0"
                            >
                                <p
                                    class="count-logo iconfont icon-bath"
                                ></p>
                                <p>
                                    <span class="number">
                                        {{
                                            count(
                                                'bathrooms',
                                                info.bathrooms
                                            )
                                        }}
                                    </span>
                                    <span class="house">
                                        {{
                                            unit(
                                                'bathrooms',
                                                info.bathrooms
                                            )
                                        }}
                                    </span>
                                </p>
                            </div>
                            <div
                                class="sqft-count clearfix"
                                v-if="
                                    info.sqft > 0 ||
                                        info.totalAvailableAcres > 0
                                "
                            >
                                <p
                                    class="count-logo iconfont icon-SqFt"
                                ></p>
                                <p>
                                    <span class="number">
                                        {{
                                            count(
                                                'sqft',
                                                info.sqft,
                                                info.totalAvailableAcres
                                            )
                                        }}
                                    </span>
                                    <span class="house">
                                        {{
                                            unit(
                                                'sqft',
                                                info.sqft,
                                                info.totalAvailableAcres
                                            )
                                        }}
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <hr class="line" />
                    <div ref="container">
                        <p v-if="soldDate" class="sold-date">{{ soldDate }}</p>

                        <DetailInfoGroup
                            :openReadMore="openReadMore"
                            firstRowClass="two-columns"
                            otherRowClass="two-columns"
                        ></DetailInfoGroup>

                        <p
                            class="read-more"
                            v-if="showReadMore"
                            @click="onReadMore"
                        >
                            <span>
                                {{
                                    openReadMore
                                        ? $t('md-sold-detail.readLessInfo')
                                        : $t('md-sold-detail.readMoreInfo')
                                }}
                                <i
                                    class="iconfont iconfont icon-arrow_04_down"
                                    :class="{ rotate180: openReadMore }"
                                />
                            </span>
                        </p>
                    </div>
                </div>
                <div class="est-request" ref="right">
                    <Request theme="broker" />
                </div>
            </div>
            <MLS
                class="f-col"
                :provided="!positionProvidedTop && 'broker'"
                theme="broker"
            ></MLS>
            <house-mask v-if="isShowMask" theme="broker" />
        </template>
        <module-box noPadding />
        <schema-info :info="seoSchema" v-if="seoSchema" />
    </div>
</template>

<script>
import { mapActions } from '@/store/helpers';

import { defineAsyncComponent } from 'vue';

import Common from '../index';
import global from '@/common/global';
import DetailBanner from './banner.vue';
import DetailInfoGroup from '../_components/detail-info-group.vue';
import MLS from '../_components/mls.vue';
import Provided from '../_components/provided';
import EstPrice from '../_components/est-price.vue';
import Request from '../_components/est-request.vue';
import noDisclosure from '@/components/nodisclosure';
import RequestButton from '../_components/est-request-button.vue';
import HouseMask from '../_components/mask.vue';
import signLog from '@/components/sign-log';
export default {
    components: {
        DetailBanner,
        MLS,
        Provided,
        DetailInfoGroup,
        EstPrice,
        Request,
        noDisclosure,
        RequestButton,
        HouseMask,
        CalculatorBroker: defineAsyncComponent(() =>
            import(
                /* webpackChunkName: "common/calculator/broker"*/ '@/components/caculator/broker.vue'
            ))
    },
    mixins: [Common],
    data: function() {
        return {
            pcCalculatorShow: false
        };
    },
    computed: {
        caculatorData: function() {
            return {
                info: this.calcInfo || {},
                initPayment: {
                    ...this.payment
                },
                onPermonthChange: money => {
                    this.updatePerMonth(money);
                },
                options: {}
            };
        }
    },
    mounted() {
        if (!this.isMobileSize) {
            this.headerHeight = 142; //md-detail-info banner sticky bar
            global.scroll(this.onScroll);
        }
    },
    unmounted() {
        if (!this.isMobileSize) {
            global.scroll(this.onScroll, true);
        }
    },
    methods: {

        ...mapActions({
            "updatePerMonth": "updatePerMonth"
        }),
        
        onScroll() {
            if (this.isMobileSize) {
                return; 
            }
            let right = this.$refs.right;
            if (!right) {
                return; 
            }

            if (this.$refs.container.offsetHeight <= right.offsetHeight) {
                if (this.status == 'unactive') {
                    return;
                }
                right.style.position = 'static';
                this.status = 'unactive';
                return;
            }
            let containerRect = this.$refs.container.getBoundingClientRect();
            let rightRect = right.getBoundingClientRect();

            if (containerRect.top > this.headerHeight) {
                if (this.status == 'normal') {
                    return; 
                }
                right.style.position = 'static';
                this.status = 'normal';
                return;
            }
            if (containerRect.top <= this.headerHeight) {
                if (
                    containerRect.bottom >
                    this.headerHeight + right.offsetHeight
                ) {
                    if (this.status == 'fixed') {
                        return; 
                    }
                    right.style.position = 'fixed';
                    right.style.left = rightRect.left + 'px';
                    right.style.top = this.headerHeight + 'px';
                    right.style.bottom = 'auto';
                    right.style.zIndex = 100;
                    this.status = 'fixed';
                } else {
                    if (this.status == 'bottom') {
                        return; 
                    }
                    right.style.position = 'absolute';
                    right.style.left = 'auto';
                    right.style.right = '0px';
                    right.style.bottom = '0px';
                    right.style.top = 'auto';
                    this.status = 'bottom';
                }
            }
        },
        pcOpenCalclator(theme) {},
        openCaculator(theme) {
            if (this.hidePrice) {
                return;
            }

            if (!this.user && this.triggerCalculator) {
                signLog.register({
                    onsuccess: () => {
                        this.doOpenCaculator(theme);
                    },
                    onLogin: () => {
                        this.doOpenCaculator(theme);
                    }
                });
            } else {
                this.doOpenCaculator(theme);
            }
        },
        setPcCalculatorShow(val) {
            this.pcCalculatorShow = val
        }
    }
};
</script>

<style lang="scss">
@import '@/theme/mixin.scss';
@import '@/theme/media.scss';
@import './mobile.scss';
@import './pc.scss';
</style>
